var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',_vm._b({attrs:{"name":_vm.icon}},'svg-icon',_vm.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }